import { Injectable } from '@angular/core';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FileFormsService, HttpService } from 'brainloper-ui';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(
    private http: HttpService,
    private formFile: FileFormsService
  ) { }

  async uploadFile(file: File): Promise<string> {
    if (!file) {
      return '';
    }

    const formFoto = this.formFile.createMultipartForm(file);
    const res: string = await this.http.postDataBody(
      `${EndpointDictionary.Docs.DOCS_SUBIR}`,
      formFoto
    );

    if (res) {
      return res;
    }
  }

  getImagen(imagen:string, companyId: number): string | null{
    if(!imagen){
      return null
    }else{
      return `${EndpointDictionary.Base._BASE_URL_V2}${imagen}/${companyId}`
    }
  }
}
